<app-header [headerStep]="headerStep" [local]="true"></app-header>
<div class="container mx-auto pb-6">
  <div class="mt-6 mb-8 space-y-6">
    <div class="flex mb-4">
      <p class="text-LC text-bold">{{ resource.lessorcertificate.titleLessor }}</p>
    </div>
    <div class="md:grid md:grid-cols-2 md:gap-4">
      <div class="flex space-y-4 md:space-y-0 md:space-x-4 md:col-span-2">
        <button
          pButton
          class="mx-auto buttonToggleSM"
          [label]="resource.lessorcertificate.private"
          [ngClass]="setClassActive(private)"
          (click)="nextStepType(lessorCertificatEnum.Private)"></button>
        <button
          pButton
          class="mx-auto buttonToggleSM"
          [label]="resource.lessorcertificate.social"
          [ngClass]="setClassActive(social)"
          (click)="nextStepType(lessorCertificatEnum.Social)"></button>
      </div>
    </div>

    <div *ngIf="social" [formGroup]="socialForm">
      <div class="md:grid md:grid-cols-2 md:gap-4">
        <div *ngIf="lessorList.length >= 6" class="my-4 md:my-0 md:col-span-2">
          <span class="p-float-label">
            <p-dropdown
              [options]="lessorList"
              [(ngModel)]="selectedLessor"
              (onChange)="onChangeLessor($event)"
              formControlName="lessor"
              optionLabel="text"
              [emptyFilterMessage]="resource.form.noResultFilterLessor"
              [placeholder]="resource.lessorcertificate.nameLessor"
              [filter]="true"
              [resetFilterOnHide]="true">
            </p-dropdown>
            <label for="float-input" class="dropdown">{{
              resource.lessorcertificate.nameLessor
            }}</label>
          </span>
          <small
            class="p-error"
            *ngIf="lessor?.touched && lessor?.invalid && (lessor?.errors)!['required']"
            >{{ resource.error.lessor }}</small
          >
        </div>
        <div *ngIf="lessorList.length < 6" class="flex flex-col my-4 md:col-span-2 space-y-4">
          <div *ngFor="let lessor of lessorList">
            <button
              pButton
              class="mx-auto buttonToggleLessorSM"
              [label]="lessor.text"
              (click)="updateLessor(lessor)"
              [ngClass]="setClassActive(lessor.text === selectedLessor?.text)"></button>
          </div>
        </div>
      </div>
    </div>

    <button
      pButton
      *ngIf="this.social"
      [disabled]="!this.socialForm.valid"
      class="mx-auto my-4 button-NS width-max iconSideLabel"
      [label]="resource.nextstep.nextStep"
      icon="pi pi-arrow-right"
      iconPos="right"
      (click)="nextStep()"></button>

    <div>
      <app-info-bottom [popUpInfo]="lessorCertificateInfo"></app-info-bottom>
    </div>
  </div>

  <div class="container mx-auto h-28 md:h-40">
    <app-footer class="footer"></app-footer>
  </div>
  <app-web-callback></app-web-callback>
</div>

